import { theme } from "antd";

export const antdTheme = {
  // antd already defaults to the light algorithm; naming it keeps the light-only rule visible here
  // instead of resting on a default someone could flip without noticing.
  algorithm: theme.defaultAlgorithm,
  token: {
    //! primary
    colorPrimaryBorder: "#224A9A",
    colorPrimary: "#224A9A",

    // The app has no hover state, so hover takes its pressed navy.
    colorPrimaryBgHover: "#1F4488",
    colorPrimaryBorderHover: "#1F4488",
    colorPrimaryHover: "#1F4488",
    colorPrimaryActive: "#1A3B78",
    fontFamily: "Inter",
  },

  components: {
    Button: {
      colorError: "#ff4d4f",
      colorErrorActive: "#d9363e",
      colorErrorBg: "#fff2f0",
      colorErrorBgActive: "#ffccc7",
      colorErrorBorderHover: "#ffa39e",
      colorErrorHover: "#ff7875",
      colorBgContainerDisabled: "rgba(209, 212, 218, 1)",
      colorTextDisabled: "#fff",
      // Flat buttons: no drop shadow under them and no focus ring around them.
      primaryShadow: "none",
      defaultShadow: "none",
      dangerShadow: "none",
      lineWidthFocus: 0,
    },
    Input: {
      activeShadow: "0 0 0 .5px #224A9A",
      // colorBorder: "rgba(209, 212, 218, 1)",
      // colorFillTertiary: "#F5F5F5",
    },
    Typography: {
      fontSizeHeading1: 38,
      fontSizeHeading2: 30,
      fontSizeHeading3: 24,
      fontSizeHeading4: 20,
      fontSizeHeading5: 16,
    },
    Divider: {
      margin: 6,
    },
    // Selection controls take the mobile kit's green rather than the navy primary.
    Checkbox: {
      colorPrimary: "#42AE5D",
      colorPrimaryHover: "#389A50",
      colorPrimaryBorder: "#42AE5D",
      fontSize: 16,
      lineHeight: 1,
    },
    Radio: {
      colorPrimary: "#42AE5D",
      colorPrimaryHover: "#389A50",
      colorPrimaryActive: "#389A50",
      colorPrimaryBorder: "#42AE5D",
    },
    Switch: {
      colorPrimary: "#42AE5D",
      colorPrimaryHover: "#389A50",
    },
    Modal: {
      borderRadiusLG: 24,
    },
  },
};
